import React from 'react'

export default function TaggedPerson(props) {
  // const moviepersons = props.taggedPersons
  // const [reload, setReload] = useState(false)

  // const handleAddOrRemoveTaggedPerson = (index, personToDeleteSK) => {
  //   props.addOrRemoveTaggedPerson(
  //     personToDeleteSK,
  //     props.editMode === 'edit' ? 0 : props.personIndex,
  //   )
  // }

  const filterIsanonymous = props.taggedPersons.filter(person => person.isAnonymous === false)
  const removedDuplicates = filterIsanonymous.filter(
    (obj, index) => index === filterIsanonymous.findIndex(o => obj.personID === o.personID),
  )

  // useEffect(() => {
  //   setReload(true)
  // }, [props.taggedPersons])
  return (
    <>
      {props.taggedPersons && props.taggedPersons.length > 0 && (
        <div
          className='card'
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '0.625rem',
            padding: '1rem',
          }}
        >
          {removedDuplicates.map((person, personIndex) =>
            // const checkIsPersonSelected = props.movieTaggedPersons.some(
            //   taggedPerson => taggedPerson.personID === person.personID,
            // )

             (
              <div
                key={personIndex}
                style={{
                  backgroundColor: '#ededed',
                  borderRadius: '1rem',
                }}
                className='pl-2 pr-2 mt-1 mb-1'
              >
                <span
                // onClick={() =>
                // handleAddOrRemoveTaggedPerson(
                // props.editMode === 'edit' ? 0 : personIndex,
                // person.personID,
                // )
                // }
                >
                  {person.name_En}{' '}
                </span>
              </div>
            ),
          )}
        </div>
      )}
    </>
  )
}
